import { useToast } from "@chakra-ui/react";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../utils";
import { CandidateAddressLookupInput, CandidateAddressLookupResult } from "../models";

export function useCandidateAddressLookup() {
    const axios = axiosInstance();
    const toast = useToast();

    return useMutation({
        mutationFn: (input: CandidateAddressLookupInput) =>
            axios.post<CandidateAddressLookupResult>(`api/clients/${input.tenantId}/entities/${input.entityId}/candidates/${input.candidateId}/AddressLookup`, {}).then(response => response.data),
        onError: error => {
            const axiosError = error as AxiosError;
            toast({
                title: "Address lookup failed",
                description: `[${axiosError.response?.status ?? "ERR"}]: ${axiosError.message}`,
                status: "error",
                isClosable: true,
                duration: null,
            });
        },
    });
}
